// @ts-ignore esModuleInterop
import React from 'react'
// @ts-ignore redux is not typed
import { connect } from 'react-redux'
import type { primitives } from '@adc/blueprint'
import { FeatureFlags } from 'common/context/listing'
import BidBanner from '../components/bidBanner'
import { upsertReoPurchaseProfile } from '../actions/user'
import { withModalHooks } from '../hooks/useModalFeatures'
type AuctionUser = primitives.AuctionUser

interface REOBidBannerProps {
  featureFlags: FeatureFlags
  user: AuctionUser
  similarProperties?: object[]
  refreshCurrentListing: () => void
  upsertReoPurchaseProfile: (profile: any) => void
}

const REOBidBanner = ({
  featureFlags,
  user,
  similarProperties,
  refreshCurrentListing,
  upsertReoPurchaseProfile,
}: REOBidBannerProps) => {
  // bidBanner has to be wrapped in a fragment to work, it seems to be rendered in another component as the child of the output of this component
  return (
    <>
      <BidBanner
        featureFlags={featureFlags}
        similarProperties={similarProperties}
        refreshCurrentListing={refreshCurrentListing}
        user={user}
        upsertReoPurchaseProfile={upsertReoPurchaseProfile}
      />
    </>
  )
}
const mapStateToProps = (store: any) => {
  return {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    user: store.user,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    similarProperties: store.propertyAnalytics.similarProperties || [],
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    featureFlags: store.featureFlags,
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  upsertReoPurchaseProfile: (profile: any) =>
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    dispatch(upsertReoPurchaseProfile(profile)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withModalHooks(REOBidBanner))
